import React from 'react';
import { Button, Layout, Row, Typography } from 'antd';
import type { ErrorInfo, ReactNode } from 'react';

import { logout } from './components/pages/Login/authSlice';
import { LOGO } from './constants';
import { RaygunErrorHandlerService } from './service/raygun.service';
import store from './store';

const { logError } = RaygunErrorHandlerService();

type Props = {
  children?: ReactNode;
};

type State = {
  hasError: boolean;
};

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
    this.goBackLogin = this.goBackLogin.bind(this);
  }

  static getDerivedStateFromError(e: Error) {
    const message = e.message?.toLowerCase() ?? '';
    const dynamicFetchError =
      message.includes('error loading dynamically imported module') ||
      message.includes('failed to fetch dynamically imported module');
    const mimeError = message.includes("'text/html' is not a valid javascript mime type.");
    if (dynamicFetchError || mimeError) {
      logError(e, ['errorBoundary', 'getDerivedStateFromError']);
      window.location.reload();
    }
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logError(error, ['ErrorBoundary', errorInfo.componentStack?.split(' ')[1] || '']); // like: "in ComponentName ..."
  }

  goBackLogin() {
    this.setState({ hasError: false });
    store.dispatch(logout());
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Layout>
          <Layout.Content className="loginPage">
            <div className="loginCard">
              <div className="loginForm">
                <img src={LOGO.src} className="loginLogo" alt={LOGO.alt} />
                <Row className="ErrorHeader">
                  <b>Oops something went wrong.</b>
                  <span style={{ marginTop: 10, marginBottom: 20 }}>Please try again in a few minutes.</span>
                </Row>
                <Row>
                  <Button type="primary" onClick={this.goBackLogin}>
                    Logout
                  </Button>
                </Row>
                <br />
                <span>
                  Having trouble?{' '}
                  <Typography.Link underline href="mailto:support@trycycle.ca">
                    Contact us
                  </Typography.Link>
                </span>
              </div>
            </div>
          </Layout.Content>
        </Layout>
      );
    }

    return this.props.children;
  }
}
